var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_4270"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u0422\\u0438\\u043F=User\\u0418\\u043D\\u0432",
    width: 42,
    height: 42,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u0422\\u0438\\u043F=User\\u0418\\u043D\\u0432",
    width: 42,
    height: 42,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_4270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 6.5625C19.5288 6.5625 18.0908 6.99902 16.8677 7.81641C15.6445 8.63281 14.6914 9.79492 14.1284 11.1543C13.5659 12.5127 13.4185 14.0088 13.7056 15.4512C13.9927 16.8936 14.7007 18.2188 15.7412 19.2598C16.7812 20.2998 18.1064 21.0078 19.5493 21.2949C20.9922 21.582 22.4878 21.4346 23.8467 20.8711C25.2056 20.3086 26.3672 19.3545 27.1846 18.1318C28.0015 16.9082 28.4375 15.4707 28.4375 13.999C28.4375 13.0225 28.2451 12.0557 27.8716 11.1533C27.4976 10.251 26.9497 9.43066 26.2593 8.74023C25.5684 8.0498 24.7485 7.50195 23.8462 7.12793C22.9438 6.75488 21.9766 6.5625 21 6.5625Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3032 23.625L15.6968 23.625C11.7998 23.625 8.98584 26.5781 8.37256 30.2793C8.26709 30.9141 8.30078 31.5645 8.4707 32.1846C8.64062 32.8047 8.94336 33.3799 9.35693 33.8711C9.77051 34.3623 10.2856 34.7559 10.8662 35.0273C11.4468 35.2979 12.0791 35.4375 12.7188 35.4375L29.2812 35.4375C29.9209 35.4375 30.5532 35.2979 31.1338 35.0273C31.7144 34.7559 32.2295 34.3623 32.6431 33.8711C33.0566 33.3799 33.3594 32.8047 33.5293 32.1846C33.6992 31.5645 33.7329 30.9141 33.6274 30.2793C33.0142 26.5781 30.2002 23.625 26.3032 23.625Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5714f803fe084ad22103e68413827e5c.svg";
export { ForwardRef as ReactComponent };